import { TncDocumentTemplate } from '../../models/interfaces/terms-and-conditions.interface';

export const APPLICANT_CONVEYANCING_CONSENT: TncDocumentTemplate = {
  document_name: 'applicant_conveyancing_consent',
  version: '2026-02-23',
  content: {
    intro: 'We, the current and proposed flat owner(s) declare that:',
    items: [
      {
        id: '1',
        text: 'I/we understand that if HDB is appointed and authorised to act for me/us in the above matter, I/we are to pay the conveyancing fees as set under the relevant HDB rules and other relevant legislation together with the stamp and registration fees and other disbursements.',
      },
      {
        id: '2',
        text: "I/we understand that in the event of the transaction being abortive and/or if I/we discharge HDB from acting for me/us or if HDB discharges itself from acting for me/us, I/we shall be liable for half of the HDB's conveyancing fees and all disbursements incurred.",
      },
      {
        id: '3',
        text: "I/we understand HDB shall be at liberty, at any point in time, to discharge itself from acting in the transaction. In such an instance, I/we shall also be liable for half of the HDB's conveyancing fees and all disbursements incurred even if the transaction is not aborted. HDB shall also be at liberty to impose further conditions*/ gather more information / query further about the parties’ family circumstances, should all parties or any party wish to continue to appoint HDB to provide conveyancing services. If upon completion, any party appears to not understand the nature and consequence of the transaction, HDB is at liberty to ask for further supporting documents before rescheduling completion. On the actual completion day, HDB is also at liberty to discharge itself from acting as solicitors for any party / all parties in the transaction.",
      },
    ],
    note: {
      id: '1',
      text: '*Further conditions may include family members who may not be involved in the ownership change but are required to a) attend completion appointment and/or b) be contacted directly by HDB ; and be queried further on their position (if any) regarding the ownership change.',
    },
  },
};
